module.exports = __webpack_public_path__ + "static/media/medium_ship.6a13d1aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/gameSpacePort/medium_ship.png
// module id = 2480
// module chunks = 0